const uiConfig = {
  "section": {
    "maxWidth": "px-8 sm:px-16 md:px-24 lg:px-0 md:max-w-screen-lg mx-auto my-4"
  },
  "input": {
    "corner": "rounded-xl",
    "bgColor": "bg-white dark:bg-neutral-800",
    "labelColor": "text-default",
    "color": "text-default",
    "shadow": "",
    "borderColor": "border-primary-700",
    "iconColor": "text-neutral-400",
    "selectionGroupHover": "hover:bg-neutral-100 dark:hover:bg-neutral-800",
    "checkbox": "bg-primary-500 border-primary-500",
    "radioBorder": "border-secondary",
    "radioBG": "bg-secondary-300",
    "switch": "bg-secondary-300",
    "switchNotCheck": "bg-neutral-300 dark:bg-neutral-600"
  },
  "img": {
    "fit": "",
    "corner": "rounded-md",
    "shadow": ""
  },
  "card": {
    "corner": "rounded-2xl",
    "bgColor": "bg-body-light",
    "shadow": "",
    "borderColor": "border-neutral-300"
  },
  "button": {
    "corner": "rounded-full",
    "shadow": ""
  },
  "datatable": {
    "pagination": false,
    "pageSize": 10,
    "headerBg": "bg-neutral-100 dark:bg-neutral-800",
    "columnBg": "bg-neutral-50 dark:bg-neutral-700",
    "headerIsDark": false,
    "responsive": {
      "filterBtn": "primary",
      "bgDropdown": "bg-primary-200"
    }
  },
  "navbar": {
    "color": "text-header",
    "bgColor": "bg-BGheader",
    "hover": "hover:text-neutral-600",
    "active": "font-bold",
    "activeMenuBottom": "bg-BGheader brightness-90",
    "icon": "text-neutral-500",
    "btnClass": "bg-primary-500 border-primary-500 text-default hover:brightness-90 contrasted:bg-default contrasted:border-default contrasted:text-white",
    "btnType": "null"
  },
  "footer": {
    "color": "text-footer",
    "bgColor": "bg-BGfooter",
    "hover": "hover:text-neutral-800",
    "btnClass": "bg-primary-500 border-primary-500 text-BGfooter hover:brightness-90 dark:bg-primary dark:border-primary dark:text-white dark:hover:brightness-110"
  },
  "tabs": {
    "selected": "bg-primary",
    "selectedText": "text-primary-600"
  },
  "dialog": {
    "bg": "bg-body-light",
    "primaryBtn": "primary",
    "secondaryBtn": "text",
    "width": 28
  },
  "photoGrid":{
    "column": 3,
    "height": 200,
    "corner": "rounded-lg",
    "shadow": "shadow-md"
  },
   "blockSplit": {
    "corner": "rounded-2xl",
    "shadow": ""
  },
  "imageBackground": {
    "corner": ""
  }
}

export default uiConfig;